export default __webpack_public_path__ + "static/media/CAMP_Site_Logo.2efeaf84.png";